import React from 'react';
import Divider from 'material-ui/Divider';
import muiThemeable from 'material-ui/styles/muiThemeable';

class TitleMedium extends React.Component {

    render() {
        return (
            <div>
                <div style={{
                fontSize:15,
                color: this.props.muiTheme.palette.primary1Color,
                paddingBottom:10,
                paddingTop:5}}>
                    {this.props.title}
                </div>
                <Divider/>
            </div>
        );
    }
}

export default muiThemeable()(TitleMedium)



// WEBPACK FOOTER //
// ./src/components/shared/utils/TitleMedium.js